import {useEffect} from "react";
import {Alert} from "react-bootstrap";
import {useTheCellMapContext} from "../contexts/TheCellMapContext";
import {AppSettings} from "../settings";
import {AlertType} from "../types/enums";

const AlertController = () => {
  const {alerts, clearErrors, removeAlert} = useTheCellMapContext();

  const errorAlerts = alerts.filter(alert => alert.type === AlertType.Error);
  const otherAlerts = alerts.filter(alert => alert.type !== AlertType.Error);

  // Auto-dismiss other alerts after some delay
  useEffect(() => {
    otherAlerts.forEach((alert) => {
      const timer = setTimeout(() => {
        removeAlert(alert);
      }, 4000);

      // Cleanup if component unmounts or alerts change
      return () => clearTimeout(timer);
    });
  }, [otherAlerts, removeAlert]);

  if (!alerts.length) return null;

  const mailtoHref = AppSettings.CONTACT_LIST
    .map(({name, email}) => `${name} <${email}>`)
    .join('; ');

  const mailtoParams = {
    subject: 'TheCellMap Error',
    body: 'Please describe the issue in detail.'
  }

  const mailtoQuery = Object.entries(mailtoParams)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

  return (
    <div id="alert-container">
      {errorAlerts.length > 0 && (
        <Alert
          variant="danger"
          dismissible
          onClose={clearErrors}
        >
          {errorAlerts.map((alert, i) => (
            <span key={i}>{alert.message}<br/></span>
          ))}
          <span>
          If the issue persists, please contact <a
            target="_blank"
            href={`mailto:${mailtoHref}?${mailtoQuery}`}
            rel="noreferrer">
            developers
          </a>.
        </span>
        </Alert>
      )}

      {otherAlerts.map((alert, i) => (
        <Alert
          key={i}
          variant={alert.type}
          dismissible
          onClose={() => removeAlert(alert)}
        >
          <span>{alert.message}</span>
        </Alert>
      ))}
    </div>
  );
};

export default AlertController;
